import React from 'react';
import General_Master from './General_Master';
import '../../CommonCSS/SocietyCSS.css'

const General_MasterApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>General Masters </h5>
          </div>
        </div>
        <General_Master />
      </div>
    </div >
  );
};

export default General_MasterApp;
